// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"5934433c","769":"496c8ba0"}[chunkId] + ".chunk.css";
};